import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/core/services/app-service';
import { Router, NavigationStart } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../base.component';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss']
})
export class NavmenuComponent extends BaseComponent implements OnInit {
  rippleColor = 'rgba(255, 255, 255, 0.1)';
  public appEnvironment = environment;

  // menuItems = [{
  //   DisplayName: 'Encounter',
  //   AccessPath: 'encounters',
  //   IconClass: 'people',
  //   IconLibrary: 'material', // could be 'material' or 'fontawesome'
  // },
  // {
  //   DisplayName: 'Report',
  //   AccessPath: 'report',
  //   IconClass: 'fas fa-file-contract',
  //   IconLibrary: 'fontawesome',
  // },
  // {
  //   DisplayName: 'Diagnosis',
  //   AccessPath: 'login',
  //   IconClass: 'fas fa-stethoscope',
  //   IconLibrary: 'fontawesome',
  // },
  // // {
  // //   DisplayName: 'Provider',
  // //   AccessPath: 'login',
  // //   IconClass: 'fas fa-user-md',
  // //   IconLibrary: 'fontawesome',
  // // },
  // {
  //   DisplayName: 'Case Manager',
  //   AccessPath: 'login',
  //   // IconClass: 'fas fa-file-medical',
  //   IconClass: 'fas fa-tasks',
  //   IconLibrary: 'fontawesome',
  // },
  // {
  //   DisplayName: 'Facility',
  //   AccessPath: 'login',
  //   IconClass: 'fas fa-clinic-medical',
  //   IconLibrary: 'fontawesome',
  // },
  // {
  //   DisplayName: 'LOS',
  //   AccessPath: 'login',
  //   IconClass: 'how_to_reg',
  //   IconLibrary: 'material',
  // },
  // {
  //   DisplayName: 'Procedure',
  //   AccessPath: 'login',
  //   IconClass: 'fas fa-procedures',
  //   IconLibrary: 'fontawesome',
  // },
  // {
  //   DisplayName: 'User',
  //   AccessPath: 'users',
  //   IconClass: 'person',
  //   IconLibrary: 'material',
  // },


  // // {
  // //   DisplayName: 'Customer',
  // //   AccessPath: 'customers',
  // //   IconClass: 'how_to_reg',
  // //   IconLibrary: 'material',
  // // },
  // // {
  // //   DisplayName: 'Regular Pagination',
  // //   AccessPath: 'projects-regular-pagination',
  // //   IconClass: 'fab fa-codepen',
  // //   IconLibrary: 'fontawesome',
  // // },
  // // {
  // //   DisplayName: 'Infinite Scroll',
  // //   AccessPath: 'projects-infinite-scroll',
  // //   IconClass: 'panorama_fish_eye',
  // //   IconLibrary: 'material',
  // // },
  // // {
  // //   DisplayName: 'Demo Edit',
  // //   AccessPath: 'projects-demo-edit',
  // //   IconClass: 'apps',
  // //   IconLibrary: 'material',
  // // },
  // // {
  // //   DisplayName: 'Inline Edit',
  // //   AccessPath: 'projects-inline-edit',
  // //   IconClass: 'edit',
  // //   IconLibrary: 'material',
  // // },
  // // {
  // //   DisplayName: 'Product',
  // //   AccessPath: 'products',
  // //   IconClass: 'layers',
  // //   IconLibrary: 'material',
  // // }
  // ];

  rowSpinnerDiameter = 32;

  activeRouteUrl = null;
  menuItems = null;

  subMenuPanelOpenedYN = false;
  menuItemSelected = null;

  constructor(
    private router: Router,
    public appService: AppService,
    protected authenticationService: AuthenticationService,
    ) {
      super(authenticationService);
     }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.activeRouteUrl = val.url;
        this.setParentMenuItemActiveState();
      }
    });

    this.appService.leftMenuItems$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(menuItems => {
      this.menuItems = menuItems;
      setTimeout(() => {
        this.setParentMenuItemActiveState();
      });     
    });
  }


  setParentMenuItemActiveState() {
    if (this.menuItems && this.menuItems.length > 0) {
      //Reset ActiveParentYN to false for all menu items
      for (const item of this.menuItems) {
        item.ActiveParentYN = false;
      }

      //Find and set to active the menu items corresponding to the actieve route.
      if (this.activeRouteUrl && this.activeRouteUrl.length > 0) {
        const activeParents = this.menuItems.filter(i => i.Children && i.Children.length > 0 && i.Children.filter(c => this.activeRouteUrl.endsWith(c.AccessPath)).length > 0);
        for (const parentItem of activeParents) {
          parentItem.ActiveParentYN = true;
        }
      }
    }
  }


  menuItemClicked(item: any) {
    // console.log('Menu Item', item);
    if (item && item.Children && item.Children.length > 0) {
      if (this.menuItemSelected === item) {
        this.subMenuPanelOpenedYN = !this.subMenuPanelOpenedYN;
      } else {
        this.subMenuPanelOpenedYN = true;
      }
    } else {
      this.subMenuPanelOpenedYN = false;
    }
    this.menuItemSelected = item;
  }


  subMenuItemClicked(item: any) {
    this.menuItemSelected = item;
    this.closeSubMenu();
  }


  closeSubMenu() {
    this.subMenuPanelOpenedYN = false;
  }


}
